function isSmartphone() {
  return window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
}

$(function(){
  //shops_map.htmlページでのみ発火
  if(document.URL.match(/shops_map/)){
    // 地域・店舗タイプごとに並び替え
    sortStoresRegionAndType(function(){
      // マップ作成
      initMap(function(){
        // 店舗検索処理
        storeMapSearchProcess();
      
        // 店舗リストとマップ表示の切り替え
        switchShopListAndMap();

        // 店舗情報のポップアップ表示処理
        handleListClickShowPopup();

        // 並び替え完了後にアコーディオン
        initShopAccordion();
      });
    });
  }
});

/**
 * 店舗検索処理
 */
function storeMapSearchProcess(){
  let isReload = true;// ページ読み込み時かどうか
  
  // ページ読み込み時、直営店・グローバルの店舗を表示
  $('.js-mapstor-type input[name="direct"],.js-mapstor-type input[name="global"]').prop('checked',true);

  // メイン処理を実行
  storeMapSearchProcessMain( isReload );
  
  
  // Enterキー押下時
  window.document.onkeydown = function(event){
    isReload = false;
    if (event.key === 'Enter') {
      // メイン処理を実行
      storeMapSearchProcessMain( isReload );
    }
  }
    
  // 「国内直営店」「グローバル」「国内正規取扱店」ボタンをクリック時
  $(".js-mapstor-type").on("click",function(){
    isReload = false;  
    // メイン処理を実行
    storeMapSearchProcessMain( isReload );
  });
}

/**
 * 店舗検索メイン処理
 */
function storeMapSearchProcessMain( isReload ){
  const storeListarea =  ".js-shops-list";// 店舗リストエリア
  const shopCount = 0;// 表示する店舗の数をカウント

  // 店舗リストを非表示
  storeListHidden(storeListarea, function() {
    // 店舗を抽出し、マーカーを表示し直す
    narrowStore(shopCount);
  
    // ページ読み込み時、ピンの場所に関わらずマップの表示範囲を固定
    if (isReload) {
      fixedMapDisplayRange();
    }

    // 検索時、地域ごとに店舗数を表示
    countStoresByRegion();

    // 店舗リストを表示
    storeListDisplay(storeListarea);
  });
}

/**
 * ピンの場所に関わらずマップの表示範囲を固定
 */
function fixedMapDisplayRange(){
  // 表示させたい範囲を定義（左下と右上の位置座標）
  const latLngBounds = new google.maps.LatLngBounds(
  new google.maps.LatLng(27.396308, 132.93457), // 南西（左下）
  new google.maps.LatLng(48.551483, 140.820892) // 北東（右上）
  ) ;

  //地図のビューポート(位置座標とズーム値)を変更
  //fitBounds( 表示範囲, 上下左右の余白)
  GLOBAL_AHKAHSHOPS.StoresMap.mapObj.fitBounds( latLngBounds, 0 );
}

/**
 * 店舗リストを非表示
 */
function storeListHidden(storeListarea, callback){
  $(storeListarea).css("opacity", 0);
  // transition0.3s完了後に callback 実行
  setTimeout(() => {
    if (typeof callback === 'function') {
      callback();
    }
  }, 400);
}

/**
 * 店舗を抽出し、マーカーを表示し直す
 */
function narrowStore(shopCount){
  const storeSearchText = ".js-shops-search";//検索キーワード
  const storeListitem = ".js-listbox";//各店舗リスト
  const noneAllShop = ".js-noshop-text"; //店舗が1つもないときに表示するテキスト
  const targetText = ".js-shops-keyword";//検索対象エリア
  //検索キーワードを空白スペースで区切り、配列に格納
  const searchKeyword = $(storeSearchText).val();
  const searchKeywordArray = searchKeyword.split(/\s+/);

  //一旦すべての店舗を非表示
  $(storeListitem).hide();
  //「該当店舗がありません」を非表示
  $(noneAllShop).hide();
  
  //直営店、正規取扱店の値を取得
  for( let i=0; i < $('.js-mapstor-type input:checked').length; i++ ){
    //店舗の種類を取得（直営店、正規取扱店）
    const searchStoreType = $('.js-mapstor-type input:checked + label').eq(i).text();

    //店舗の数だけ処理を繰り返す
    $(storeListitem).each(function(){
      //全店舗の種類を取得
      const storeType = $(this).find('.js-shop-category').text();

      //検索範囲内のテキスト
      let searchTargetText = $(this).find(targetText).text();
      //半角スペースを省く
      searchTargetText = searchTargetText.replace(/\s/g,"");

      //検索かけた店舗の種類と一致かつ検索範囲に全ての検索キーワードが含まれていれば、該当店舗を表示
      const isWordMatch = compareSearchWord(searchKeywordArray,searchTargetText);
      //console.log(searchStoreType,`店舗マスタ：${storeType}`);
      if( searchStoreType.includes(storeType) && isWordMatch ){
        //店舗を表示
        $(this).show();
        //表示する店舗の数をカウント
        shopCount ++;
      }
    });
  }

  //マーカーをすべて削除
  deleteStoreMapMarker();
  
  //店舗ごとの位置情報データを配列に格納
  const someStoresMarkerData = setStoreMapDataArray();
  //再度マーカーを立て直す
  setStoreMapMarker(someStoresMarkerData);

  //マップを検索された店舗の中心に移動
  moveMapCenterSearchedStore( someStoresMarkerData );
  
  //該当店舗がないとき「該当店舗がありません」を表示
  if(shopCount == 0){
    $(noneAllShop).show();
  }
};

  
/**
 * 検索範囲にすべてのキーワードが含まれているか判定
 * @param searchKeywordArray - 検索キーワードの配列
 * @param searchTargetText - 検索対象のテキスト
 */
function compareSearchWord(searchKeywordArray,searchTargetText){
  let hitWordCount = 0;
  //検索キーワードの数だけ繰り返す
  for(let i=0; i<searchKeywordArray.length; i++){
    //完全一致する単語があるか比較
    if(searchTargetText.indexOf(searchKeywordArray[i]) != -1){
      hitWordCount ++;
    }
  }

  //全ての検索キーワードが含まれていればtrueを返す
  if(searchKeywordArray.length == hitWordCount){
    return true;
  }else{
    return false;
  }
}  

/**
 * 店舗リストを表示
 * @param storeListarea - ".js-shops-list"（店舗リストのエリア）
 */
function storeListDisplay(storeListarea){
  //店舗を表示  
  $(storeListarea).css("opacity", 1);
};

/**
 * マップを検索された店舗の中心に移動
 * @param someStoresMarkerData - 店舗情報の配列
 * @param someStoresMarkerData[].markerDataLat - 緯度
 * @param someStoresMarkerData[].markerDataLng - 経度
 * @param someStoresMarkerData[].markerDataName - 店舗名
 * @param someStoresMarkerData[].markerDataType - 店舗タイプ（例: "直営店"）
 */
function moveMapCenterSearchedStore( someStoresMarkerData ){
  // 検索結果で、店舗が1つも該当しない場合は、処理しない
  if (someStoresMarkerData.length < 1) {
    return;
  }

  // マップの境界（範囲）のインスタンスを生成
  const latLngBounds = new google.maps.LatLngBounds();

  // マーカーの数分処理
  for (let i = 0; i < someStoresMarkerData.length; i++) {
    // 経度または緯度が設定されていない場合は、処理をスキップ
    if (isNaN(someStoresMarkerData[i]["markerDataLat"]) || isNaN(someStoresMarkerData[i]["markerDataLng"])) {
      continue;
    }

    // 位置座標のインスタンスを作成
    const position = new google.maps.LatLng(
      someStoresMarkerData[i]["markerDataLat"],
      someStoresMarkerData[i]["markerDataLng"]
    );

    // マップの境界（範囲）に位置座標を追加
    latLngBounds.extend(position);
  }

  // 地図のビューポート(位置座標とズーム値)を変更
  if (isSmartphone()) {
    GLOBAL_AHKAHSHOPS.StoresMap.mapObj.fitBounds(latLngBounds, 30);
  } else {
    GLOBAL_AHKAHSHOPS.StoresMap.mapObj.fitBounds(latLngBounds, 200);
  }

  // 店舗が１つのみの場合のズーム値を変更
  if (someStoresMarkerData.length === 1) {
    GLOBAL_AHKAHSHOPS.StoresMap.mapObj.setZoom(11);
  }
}

/**
 * 店舗リストとマップ表示の切り替え
 */
function switchShopListAndMap(){
  $('.js-shops-toggle').on('click', function(){
    // 「店舗リストを表示」をクリックしたら
    if($(this).data('target') === 'list'){
      // 店舗リストを表示
      $('[data-content="list"]').show();
      //ボタン表示の切り替え
      $(this).removeClass('is-show');
      $('[data-target="map"]').addClass('is-show');
      //「直営店」等の非表示
      $('.js-mapstor-type').hide();

    // 「マップを表示」をクリックしたら
    }else{
      // 店舗リストを非表示
      $('[data-content="list"]').hide();
      //ボタン表示の切り替え
      $(this).removeClass('is-show');
      $('[data-target="list"]').addClass('is-show');
      //「直営店」等の表示
      $('.js-mapstor-type').show();
    }    
  });
};

/**
 * 店舗リストクリック時の、店舗情報のポップアップ表示処理
 */
function handleListClickShowPopup(){
  //店舗選択時
  $('.js-shops-name').on('click', function(){
    if($(this).siblings('.js-shops-info').hasClass('is-open')){
      // ポップアップを閉じる
      closeStorePopup();
    }else{
      // 今開いているポップアップがあれば閉じる
      $('.js-shops-info').removeClass('is-open');
      // 対象のポップアップを開く
      const targetPopup = $(this).siblings('.js-shops-info');
      targetPopup.addClass('is-open');
      $('.js-shops-list').addClass('is-open');
    }
  });
  
  //戻るボタン、閉じるボタンでポップアップを閉じる
  $('.js-shop-info-back').on('click', function(){
    closeStorePopup();
  });
}

// 店舗情報のポップアップを閉じる処理
function closeStorePopup(){
  $('.js-shops-info').removeClass('is-open');
  $('.js-shops-list').removeClass('is-open');
}

/**
 * マーカークリック時の、店舗情報のポップアップ表示処理
 */
function handleMarkerClickShowPopup(i,markerData){
  const $container = $('.js-shops-list');
  const containerHeight = $container.outerHeight();

  let $targetShop = null;
  // 開いているポップアップがあれば閉じる
    $('.js-shops-info').removeClass('is-open');

  $('.js-listbox').each(function(){
    const thisShopsName = $(this).find('.js-shops-name').text().trim();
    // クリックした店舗の店舗リストの要素を特定
    if(thisShopsName === markerData[i].markerDataName){
      $targetShop = $(this);
      return false;
    }
  });


  if($targetShop){
    // 対象の地域を展開
    $targetShop.parents('.js-shop-accordion').find('.js-shop-accordion__trigger:not(.is-open)').trigger('click');
    // 対象の店舗リストが中央に表示されるようスクロール
    const targetTop = $targetShop.get(0).offsetTop;
    const scrollTo = targetTop - (containerHeight/2);
    $container.animate({ scrollTop: scrollTo }, 400);
    // 対象のポップアップを開く
    const targetPopup = $targetShop.find('.js-shops-info');
    targetPopup.addClass('is-open');
    $container.addClass('is-open');

    // スマホも、店舗情報を表示する
    if(isSmartphone()){
      // 店舗リストを表示
      $('[data-content="list"]').show();
      //ボタン表示の切り替え
       $('.js-shops-toggle').removeClass('is-show');
      $('[data-target="map"]').addClass('is-show');
      //「直営店」等の非表示
      $('.js-mapstor-type').hide();      
    }
  }else{
    console.warn('対応する店舗が見つかりませんでした');
  }
}

/**
 * 地域・店舗タイプごとに並び替え
 */
function sortStoresRegionAndType(callback){  

  // メタフィールドの値順に並び替え
  sortStoresByMetafieldOrder();
  
  // 店舗リスト
  const storeListItem = $('.js-listbox');
  
  // 店舗の種類（直営店・正規取扱店）をキーにした連想配列を作成
  let storeTypeObj = {};//（例：{直営店:{北海道:[a,b.c.d...]},{関東:[a,b,c,d,...]},正規取扱店:{北海道:[a,b.c.d...]},{関東:[a,b,c,d,...]}}）

  storeListItem.each(function(){
    //店舗タイプ（直営店・グローバル・正規取扱店）を取得
    const storeTypeKey = $(this).find( '.js-shop-category' ).text();

    //地域を取得
    const storeRegionKey = $(this).data('region');

    // 店舗タイプ（直営店・正規取扱店）をキーに連想配列の値が未設定の場合は空の連想配列で初期化
    if ($.type(storeTypeObj[storeTypeKey]) === 'undefined'){
      storeTypeObj[storeTypeKey] = {};
    }
    // 地域をキーに連想配列の値が未設定の場合は空の配列で初期化
    // console.log(storeTypeKey,storeRegionKey);
    if ($.type(storeTypeObj[storeTypeKey][storeRegionKey]) === 'undefined'){
      storeTypeObj[storeTypeKey][storeRegionKey] = [];
    }
    // 店舗の種類（直営店・正規取扱店）をキーに対象の店舗情報を地域ごとに配列に追加
    storeTypeObj[storeTypeKey][storeRegionKey].push($(this).clone());
    //console.log(storeTypeObj);
  });
  
  // 店舗の種類（直営店・グローバル・正規取扱店）の中に地域ごとにまとめた店舗一覧を作り直す
  createCollectStoreList(storeTypeObj);

  // 完了後に callback 実行
  if (typeof callback === 'function') {
    callback();
  }
}

/**
 * メタフィールドの値順に並び替え
 */
function sortStoresByMetafieldOrder(){
  const container = '.js-shops-list';// 各店舗を包括している親要素のclass名
  const $items = $(container).find('.js-listbox__wrapper');// 並び替えたい要素をすべて取得

  // 店舗をメタフィールド[shops_sort]の数順に並び替え
  const sortedItems = $items.sort(function(a, b) {
    // data-sort属性の値を取得。存在しないか空の場合はInfinity（無限大）とする
    const sortA = parseInt($(a).data('sort')) || Infinity;
    const sortB = parseInt($(b).data('sort')) || Infinity;

    // 数値の小さい順（昇順）でソート
    return sortA - sortB;
  });

  // 並び替えた順序で、店舗の要素を親コンテナに再配置
  sortedItems.each(function() {
    $(this).appendTo($(container));
  });
}
  
/**
 * 店舗の種類（直営店・グローバル・正規取扱店）の中に地域ごとにまとめた店舗一覧を作り直す
 */
function createCollectStoreList(storeTypeObj){
  // 新しい店舗リスト
  const newStoreList = [];
  //  店舗の種類（直営店・グローバル・正規取扱店）ごとに処理
  $.each(storeTypeObj, function(type, regionObj) {
    //地域ごとにまとめた店舗情報の配列を生成
    const regionStoreArray = createCollectedStore(regionObj);
    //店舗の種類（直営店・正規取扱店）の表示するdivタグを生成
    const $storeTypeHead = $('<h2 />').addClass('p-shops-list__head');
    $storeTypeHead.text( type );
    // 地域ごとに店舗を集約したsectionタグを生成
    const $storeTypeContent = $('<section />').addClass('p-shops-list__sec');
    //sectionに地域名のdivタグを追加
    $storeTypeContent.append($storeTypeHead);
    //地域ごとにまとめた店舗情報を地域ごとのsectionタグ内に追加
    for(let i=0; i<regionStoreArray.length; i++ ){
      $storeTypeContent.append(regionStoreArray[i]);
    }
    //新しい店舗リストの配列に格納
    newStoreList.push($storeTypeContent);    
  });
  
  // 商品一覧を書き換える
  $('.js-listbox__wrapper').remove();
  for( let i=0; i < newStoreList.length; i++ ){
    $('.js-shops-list').append(newStoreList[i]);
  }
}

/**
 * 地域ごとにまとめた店舗情報の配列を生成
 * @param regionObj 地域名をキーにした連想配列 例：{関東：Array(2), 関西:Array(3), ...}
 */
function createCollectedStore( regionObj ){
  const storeItemArray = [];//各商品情報
  
  $.each(regionObj, function(regionName, regionStoreItemArray) {
    //地域名を表示するdivタグを生成
    const regionHead = $('<div />').addClass('p-shops-list__region js-shop-accordion__trigger');
    regionHead.text( regionName );
    // 地域ごとに店舗を集約するsectionタグを生成
    const regionContent = $('<div />').addClass('p-shops-list__items js-shop-accordion');
    //sectionに地域名のdivタグを追加
    regionContent.append(regionHead);
    // 店舗だけを集約したdivタグを生成
    const regionShopContainer = $('<div />').addClass('js-shop-accordion__content');
    //sectionに店舗だけを集約するdivタグを追加
    regionContent.append(regionShopContainer);
    //sectionに店舗情報を追加
    for(let shopItem of regionStoreItemArray){
      regionShopContainer.append(shopItem.clone());
    }
    //地域ごとにまとめた店舗情報を配列に追加
    storeItemArray.push(regionContent);
  });
  
  return storeItemArray;
}

/**
 * 地域ごとに店舗数を表示
 */
function countStoresByRegion() {
  // 一旦全地域・全店舗タイプのエリアを表示
  $('.p-shops-list__items, .p-shops-list__sec').show();

  $('.p-shops-list__items').each(function () {
    // 各地域の店舗数を取得（自身の表示状態だけ確認）
    const shopsCount = $(this).find('.js-listbox').filter(function () {
      return $(this).css('display') !== 'none';
    }).length;

    // すでに店舗数のspanがあるか確認
    let countElement = $(this).find('.p-shops-list__count');

    if (countElement.length) {
      // 既存のspan要素があれば、内容を更新
      countElement.text(`(${shopsCount})`);
    } else {
      // 既存のspan要素がなければ、新たに作成して追加
      countElement = $('<span />')
        .addClass('p-shops-list__count')
        .text(`(${shopsCount})`);
      // 地域名（<dt>）の中に店舗数を追加
      $(this).find('.p-shops-list__region').append(countElement);
    }

    // 店舗が1つもない場合は、地域ごと非表示
    if (shopsCount === 0) {
      $(this).hide();
    }
  });

  $('.p-shops-list__sec').each(function () {
    // 各店舗タイプの店舗数を取得
    const shopsCount = $(this).find('.js-listbox').filter(function () {
      return $(this).css('display') !== 'none';
    }).length;

    // 店舗が1つもない場合は、店舗タイプごと非表示
    if (shopsCount === 0) {
      $(this).hide();
    }
  });
}

// アコーディオンメニュー
function initShopAccordion() {
  // トリガー要素（クリック部分）を全て取得して処理
  $('.js-shop-accordion__trigger').each(function () {
    const $trigger = $(this);

    // すでにクリックイベントがバインド済みなら処理をスキップ（重複バインド防止）
    if ($trigger.data('accordionBound')) return;

    // クリックイベントをバインド
    $trigger.on('click', function () {
      // クリックされたトリガーの親コンテナを取得
      const $container = $trigger.closest('.js-shop-accordion');
      // その中のコンテンツ部分を取得
      const $content = $container.find('.js-shop-accordion__content');
      const openClass = 'is-open';

      if ($content.hasClass(openClass)) {
        // すでに開いていたら閉じる
        $content
          .removeClass(openClass)  // 開いている印（クラス）を削除
          .slideUp(300);          // jQueryのアニメーションで閉じる
        $trigger.removeClass(openClass);  // トリガーの開閉状態クラスも削除
      } else {
        // 閉じていたら開く
        $content
          .addClass(openClass)  // 開いている印（クラス）を付与
          .slideDown(300);     // jQueryのアニメーションで開く
        $trigger.addClass(openClass);    // トリガーの開閉状態クラスも付与
      }
    });

    // ここまで来たらバインド済みなので、フラグをセット
    $trigger.data('accordionBound', true);
  });
}
